import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  previousPath: localStorage.getItem('previousPath') || '/',
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentPath: (state, action) => {
      state.previousPath = action.payload;
      localStorage.setItem('previousPath', action.payload);
    },
  },
});

export const { setCurrentPath } = navigationSlice.actions;

export default navigationSlice.reducer;
